/*class CartRemoveButton extends HTMLElement {
  constructor() {
    super(); 
    this.addEventListener('click', (event) => { 
      event.preventDefault();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const dataIndex= this.dataset.index;
      const dataId= this.dataset.id;
      var cartItemsCount= document.querySelector("#cartItems").value;
      console.log("INDEX")
      //console.log(cartItemsCount,"dddddd",cartItems,dataIndex)
      document.querySelector('#cartRemove').classList.add('Toastify_popup_open');
      if(document.querySelector('#cartRemoveCart')){
      document.querySelector('#cartRemoveCart').classList.add('Toastify_popup_open');
      document.querySelector('#cartRemoveCart .removeItem').dataset.index=dataIndex;
      document.querySelector('#cartRemoveCart .removeItem').dataset.giftboxexist=this.dataset.giftboxexist;
      }
      document.querySelector('.removeItem').dataset.index=dataIndex;
      document.querySelector('.removeItem').dataset.giftboxexist=this.dataset.giftboxexist;
      document.querySelectorAll('.removeItem').forEach(function(remove){
        remove.addEventListener('click', function(){
        console.log(cartItemsCount,"cartItemsCount",this.dataset)
        if(cartItemsCount == 2 && document.querySelector("#giftItem") && document.querySelector('.removeItem').dataset.giftboxexist== "false" && dataIndex.trim() !== '')
        { console.log("IF 2")
         var giftItem= document.querySelector("#giftItem").value;
         console.log(giftItem,"giftItem");
         cartItems.updateQuantity(giftItem, 0,'','variantId','no');
         setTimeout(function(){ console.log(document.querySelector('.removeItem').dataset.index,"in",dataIndex)
        //if(document.querySelector('.removeItem').dataset.index == dataIndex) {
        //const cartItems = that.closest('cart-items') || that.closest('cart-drawer-items');
         cartItems.updateQuantity(dataId, 0,'','variantId');
         document.querySelectorAll('.Toastify_popup').forEach(function(popup){popup.classList.remove('Toastify_popup_open')}); 
         document.querySelector('.removeItem').dataset.index='';
         document.querySelector('.removeItem').dataset.giftboxexist='';
        // }
         },1000);
        setTimeout(function(){const body = JSON.stringify({attributes: {'gift-message': '','gift-wrap':''} });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                             },500);
        }
        else { 
       if(document.querySelector('.removeItem').dataset.index == dataIndex && dataIndex.trim() !== '') { console.log("ELSE")
        //const cartItems = that.closest('cart-items') || that.closest('cart-drawer-items');
         cartItems.updateQuantity(dataIndex, 0);
         document.querySelectorAll('.Toastify_popup').forEach(function(popup){popup.classList.remove('Toastify_popup_open')}); 
         document.querySelector('.removeItem').dataset.index='';
        
       if(document.querySelector('.removeItem').dataset.giftboxexist== "true") {
         setTimeout(function(){const body = JSON.stringify({attributes: {'gift-message': '','gift-wrap':''} });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                             },500);  
       }
     }  
          
        }
       })
       })
    });
  }

} */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(); 
    this.addEventListener('click', (event) => { 
      event.preventDefault();

      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const dataIndex= this.dataset.index;
      const dataId= this.dataset.id;
      var cartItemsCount= document.querySelector("#cartItems").value;
      //console.log(cartItemsCount,"dddddd",cartItems,dataIndex)
      document.querySelector('#cartRemove').classList.add('Toastify_popup_open');
      if(document.querySelector('#cartRemoveCart')){
      document.querySelector('#cartRemoveCart').classList.add('Toastify_popup_open');
      document.querySelector('#cartRemoveCart .removeItem').dataset.index=dataIndex;
      document.querySelector('#cartRemoveCart .removeItem').dataset.giftboxexist=this.dataset.giftboxexist;
      document.querySelector('#cartRemoveCart .removeItem').dataset.giftboxproduct=this.dataset.giftboxproduct;
      }
      document.querySelector('.removeItem').dataset.index=dataIndex;
      document.querySelector('.removeItem').dataset.giftboxexist=this.dataset.giftboxexist;
       document.querySelector('.removeItem').dataset.giftboxproduct=this.dataset.giftboxproduct;
      // Add a flag to prevent multiple executions
      let hasClicked = false;

      document.querySelector('.removeItem').addEventListener('click', () => {
        if (!hasClicked) {
          hasClicked = true;
          this.RemoveItems(cartItems, dataIndex, dataId, cartItemsCount);
        }
    });
  });
   }
RemoveItems(cartItems,dataIndex,dataId,cartItemsCount){
     //console.log(cartItemsCount,"cartItemsCount",this.dataset)
        if(cartItemsCount == 2 && document.querySelector("#giftItem") && document.querySelector('.removeItem').dataset.giftboxexist== "false" && dataIndex.trim() !== '')
        { 
         var giftItem= document.querySelector("#giftItem").value;
         //console.log(giftItem,"giftItem");
         cartItems.updateQuantity(giftItem, 0,'','variantId','no');
         setTimeout(function(){ //console.log(document.querySelector('.removeItem').dataset.index,"in",dataIndex)
        //if(document.querySelector('.removeItem').dataset.index == dataIndex) {
        //const cartItems = that.closest('cart-items') || that.closest('cart-drawer-items');
         cartItems.updateQuantity(dataId, 0,'','variantId');
         document.querySelectorAll('.Toastify_popup').forEach(function(popup){popup.classList.remove('Toastify_popup_open')}); 
         document.querySelector('.removeItem').dataset.index='';
         document.querySelector('.removeItem').dataset.giftboxexist='';
        // }
         },1000);
       /* setTimeout(function(){const body = JSON.stringify({attributes: {'gift-message': '','gift-wrap':''} });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                             },500); */
        }
        else { 
       if(document.querySelector('.removeItem').dataset.index == dataIndex && dataIndex.trim() !== '') { 
        //const cartItems = that.closest('cart-items') || that.closest('cart-drawer-items');
         cartItems.updateQuantity(dataIndex, 0);
         document.querySelectorAll('.Toastify_popup').forEach(function(popup){popup.classList.remove('Toastify_popup_open')}); 
         document.querySelector('.removeItem').dataset.index='';
        
       if(document.querySelector('.removeItem').dataset.giftboxexist== "true" || document.querySelector('.removeItem').dataset.giftboxproduct== "true") {
         /*setTimeout(function(){const body = JSON.stringify({attributes: {'gift-message': '','gift-wrap':''} });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
                             },500);   */
       }
     }  
          
        } 
}
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
  var that=this;
    //console.log("ppp",document.querySelector("cart-drawer-items").dataset.cartdisable)
 if(document.querySelector("cart-drawer-items").dataset.cartdisable != undefined){
  const cartDisableHandle =document.querySelector("cart-drawer-items").dataset.cartdisable;
  const cartDisableHandleArray = cartDisableHandle.split(","); console.log(cartDisableHandleArray)
  cartDisableHandleArray.forEach(function(handle){
  if(document.querySelector('[data-item-'+handle+']')){
  var cartItemLine= document.querySelector('[data-item-'+handle+']').dataset.index;
    if(cartItemLine !='') {that.updateQuantity(cartItemLine, 0, 'minus');}
  }
  
})
  } 

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) { 
    var eventId= event.target.id;
    var containsSubstring = eventId.includes("cartShowRecommended");
    if(containsSubstring){ //donothing
     }else {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    }
  }

  getSectionsToRender() { 
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }//,
      //  {
      //   id: 'main-cart-recommended-products',
      //   section: document.getElementById('main-cart-recommended-products').dataset.id,
      //   selector: '.js-contents',
      // }
    ];
  }

  async updateQuantity(line, quantity, name,type='') { 
  // Custom code to block the maximum qty
 var cartSettingsInput= parseInt(cartSettings.cart_max_input);
  if(quantity > cartSettingsInput) {
  alert(cartSettings.cart_max_input_error_message);
  if (window.location.href.indexOf("cart") > -1) {
  document.querySelector("#Quantity-"+line).value=document.querySelector("#Drawer-quantity-"+line).dataset.currentquantity;
  }
  else { 
  document.querySelector("#Drawer-quantity-"+line).value=document.querySelector("#Drawer-quantity-"+line).dataset.currentquantity;
  }
  return false;
  }
  //ends
    this.enableLoading(line);

  if(type =='variantId') {
    var id =line;

      var body = JSON.stringify({
      id,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    
 
  }
else {
  var body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });  
}
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {  
        const parsedState = JSON.parse(state);

        
        if(document.querySelector("#main-cart-items")){
         var templateId= document.querySelector("#main-cart-items").dataset.id; 
         var htmlData = parsedState.sections[templateId];
        }
        else {
        var htmlData = parsedState.sections['cart-drawer'];
        }
        var tempElement = document.createElement('div');
        tempElement.innerHTML = htmlData;
        var totalTypes = tempElement.querySelector('[name="totalminiTypes"]').value;
        
        if(tempElement.querySelector('[name="pouchBoxId"]') && totalTypes < 3){
        var pouchBoxId = tempElement.querySelector('[name="pouchBoxId"]').value;
        console.log(pouchBoxId,totalTypes);
        this.updateQuantity(pouchBoxId, 0,'','variantId');
        }
        else {
       
     
        if (parsedState.item_count === 0 && window.location.href.indexOf("gift-card") > -1) {
         window.location.reload();
         }
          
       if(window.location.href.indexOf("cart") > -1) {
              window.location.reload();
        } 
        else {
           // Dispatch the custom event with the response data
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cart: parsedState,
      }
    }));
        }

   
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
 
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          //console.log(elementToReplace)
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
      'cart_count': 2,
       'event':'cart_update'
      });

          if(document.querySelector('#recommendedProductsScript')){eval(document.querySelector('#recommendedProductsScript').innerHTML); }
        if(document.querySelector('#cartRecommendedProductsScript')){eval(document.querySelector('#cartRecommendedProductsScript').innerHTML);}
        if(document.querySelector('#recommendType')) {  eval(document.querySelector('#recommendType').innerHTML);}
        if(document.querySelector('#internationalScript')) { eval(document.querySelector('#internationalScript').innerHTML);}
        if(document.querySelector('#characterCount')) { eval(document.querySelector('#characterCount').innerHTML);}

         
        //this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }

      if(document.querySelector(".CartGwpOfferBuyXGetY_sectionFound") && window.location.href.indexOf("cart") == -1) {
         checkCartForQualifyingItems();
          }
       if(document.querySelector(".CartGwpOfferBuyX2GetY_sectionFound") && window.location.href.indexOf("cart") == -1) {
         checkCartForQualifyingItems2();
          }
      if(document.querySelector(".CartTotalOffer_sectionFound") && window.location.href.indexOf("cart") == -1) {
         checkCartForOffer();
          }
        if(document.querySelector(".CartTotalOffer2_sectionFound") && window.location.href.indexOf("cart") == -1) {
         checkCartForOffer2();
          } 
          
               this.disableLoading();
        }
        
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {  
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);

      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({attributes: {'gift-message': event.target.value,'gift-wrap':'Yes' } });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
/*
if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  });
};
*/
